// extracted by mini-css-extract-plugin
export var container = "_ss-0";
export var dotAnimation = "_ss-2";
export var dotsLoading = "_ss-1";